var exports = {
  "container": "x9bf38834--ce344e--container",
  "title": "x9bf38834--ce344e--title",
  "list": "x9bf38834--ce344e--list",
  "item": "x9bf38834--ce344e--item",
  "step-one": "x9bf38834--ce344e--step-one",
  "step-two": "x9bf38834--ce344e--step-two",
  "step-third": "x9bf38834--ce344e--step-third",
  "step-fourth": "x9bf38834--ce344e--step-fourth",
  "item-title": "x9bf38834--ce344e--item-title",
  "image": "x9bf38834--ce344e--image",
  "button-img": "x9bf38834--ce344e--button-img",
  "vas-img": "x9bf38834--ce344e--vas-img",
  "coin-img": "x9bf38834--ce344e--coin-img",
  "advert-img": "x9bf38834--ce344e--advert-img",
  "phone": "x9bf38834--ce344e--phone",
};

module.exports = exports;
